import React from 'react'
import LIlogo from '../../../../images/linkedinLogo.png'
import {
    // ArrowCircleLeftIcon,
    RefreshIcon
} from '@heroicons/react/outline';
import GenerateButton from './subcomponents/GenerateButton';
import ContentGenerated from './subcomponents/ContentGenerated';
import CopyAndFireButtons from './subcomponents/CopyAndFireButtons';
// import SearchForProspect from '../SearchForProspect/SearchForProspect';
import SearchProspect from './subcomponents/SearchProspect';
// import MsgAndInt from './subcomponents/MsgAndInt';
import BounceLoader from "react-spinners/BounceLoader";
import { css } from "@emotion/core";


//image
import ElonMuskImg from '../../../../images/ElonMusk.jpg';
import Default from '../../../../images/default.png'
import CustomTopic from './subcomponents/CustomTopic';
import ButtonsForInt from './subcomponents/ButtonsForInt';
import SelectVprop from './subcomponents/SelectVprop';
// import ClickMessageType from './subcomponents/ClickMessageType';
import LinkedInHK from '../Functions/Hotkeys/LinkedInHK';
import { regenInterests } from '../Functions/AIFunctions/RegenInterests';
// import OneLinerToggle from './subcomponents/OneLinerToggle';
// import ActionInitToggle from './subcomponents/ActionInitToggle';
import ModelTabs from './subcomponents/ModelTabs';
// import GetEmail from './subcomponents/GetEmail';

const override = css`
  display: inline-block;
`;

function Profile({
    profile,
    interests,
    contentGen,
    setIntVal,
    intVal,
    FBvalueProp,
    selectedVprop,
    valueIndex,
    setShownButton,
    shownButton,
    fbProfile,
    vProp,
    auth,
    setContentGen,
    setGenerating,
    tokens,
    docId,
    url,
    foundInts,
    interestValues,
    callToAction,
    setBtnClicked,
    setShowTooltip,
    generating,
    firstCopy,
    fireClicked,
    editing,
    setEditing,
    showBtn,
    setURL,
    setError,
    setDocId,
    setInterests,
    setFoundInts,
    setShowSearching,
    setProfile,
    backButton,
    setShowProfileVpropAdd,
    onboarded,
    intLoad,
    setIntLoad,
    setEmailFinderGen,
    emailFinderGen,
    email,
    setEmail,
    teamToken,
    tokensTeam,
    oneLinerModel,
    setOneLinerModel,
    actionInitModel,
    setActionInitModel,
    probingModel,
    setProbingModel
}) {

    // function classNames(...classes) {
    //     return classes.filter(Boolean).join(' ')
    //   }

    return (
        <div className="max-w-7xl mb-10">
            <div className="flex mb-4 -mt-5">
            <SearchProspect 
                setShowSearching={setShowSearching}
                setProfile={setProfile}
                auth={auth}
                fbProfile={fbProfile}
                setFoundInts={setFoundInts}
                setInterests={setInterests}
                setDocId={setDocId}
                setContentGen={setContentGen}
                setError={setError}
                url={url}
                setURL={setURL}
                setIntVal={setIntVal}
                setEmail={setEmail}
            />
            <div className="ml-auto">
                <GenerateButton 
                shownButton={shownButton}
                profile={profile} 
                fbProfile={fbProfile} 
                vProp={vProp}
                intVal={intVal}
                auth={auth}
                setContentGen={setContentGen} 
                setGenerating={setGenerating}
                tokens={tokens}
                docId={docId}
                LIurl={url}
                interests={interests} 
                foundInts={foundInts}
                interestValues={interestValues}
                setBtnClicked={setBtnClicked}
                setShowTooltip={setShowTooltip}
                callToAction={callToAction}
                setEditing={setEditing}
                generating={generating}
                showBtn={showBtn}
                teamToken={teamToken}
                tokensTeam={tokensTeam}
                oneLinerModel={oneLinerModel}
                actionInitModel={actionInitModel}
                probingModel={probingModel}
                />
            </div>
            </div>
            {/* Buttons to click message type */}
            {/* <ClickMessageType 
            setShownButton={setShownButton}
            onboarded={onboarded}
            auth={auth}
            shownButton={shownButton}
            /> */}
            <div className="border-none border-indigo-200 flex xs:block">
                {/* Left Side Div */}
                <div className="w-1/2">
                    {/* Profile Block */}
                    <div className="bg-white shadow sm:rounded-lg ">
                        {/* Profile Info */}
                        <div className='flex'>
                        {(profile.full_name === 'Elon Musk') ? 
                            <img 
                                src={ElonMuskImg} 
                                alt='searched' 
                                className="rounded-full p-4 h-32"
                            /> 
                        :
                            (profile?.profile_pic_url?.includes("proxycurl") ?
                            <img 
                            src={Default} 
                            alt='searched' 
                            className="rounded-full p-4 h-32"
                            />
                            :
                            <img 
                            src={profile?.profile_pic_url} 
                            alt='searched' 
                            className="rounded-full p-4 h-32"
                            />
                            )
                        }
                            {/* <img src={profile?.profile_pic_url} alt='bio' className="rounded-full p-4 h-32"/> */}
                            <div className="py-4 max-w-lg overflow-auto flex-wrap">
                                <h2 className="text-2xl font-bold ml-1 mt-1">{profile.full_name}</h2>
                                <h2 className="text-base font-medium mt-1 ml-1 truncate">{profile.occupation}</h2>
                                <h2 className="text-sm font-normal mt-1 ml-1">{profile.city}</h2>
                            </div>
                            {/* Select Value Prop */}
                            {/* <div className=" ml-8"> */}
                            <div className="ml-2 mt-2">
                                <SelectVprop 
                                valueIndex={valueIndex}
                                selectedVprop={selectedVprop}
                                FBvalueProp={FBvalueProp}
                                setShowProfileVpropAdd={setShowProfileVpropAdd}
                                onboarded={onboarded}
                                auth={auth}
                                />
                                {/* <div className="mt-4 ml-2">
                                    <OneLinerToggle 
                                    oneLinerModel={oneLinerModel}
                                    setOneLinerModel={setOneLinerModel}
                                    setActionInitModel={setActionInitModel}
                                    />
                                </div>
                                <div className="mt-2 mb-6 ml-2">
                                    <ActionInitToggle 
                                    actionInitModel={actionInitModel}
                                    setActionInitModel={setActionInitModel}
                                    setOneLinerModel={setOneLinerModel}
                                    />
                                </div> */}
                            </div>
                            {/* <div className="my-4 mr-3">
                                <GetEmail 
                                setEmailFinderGen={setEmailFinderGen}
                                emailFinderGen={emailFinderGen}
                                email={email}
                                setEmail={setEmail}
                                profile={profile}
                                url={url}
                                />
                            </div> */}
                            {/* </div> */}
                        </div>
                        <div className="justify-center mb-4">
                        <ModelTabs 
                            actionInitModel={actionInitModel}
                            oneLinerModel={oneLinerModel}
                            setActionInitModel={setActionInitModel}
                            setOneLinerModel={setOneLinerModel}
                            probingModel={probingModel}
                            setProbingModel={setProbingModel}
                        />
                        </div>
                    </div>
                    <div
                    className="bg-white rounded-md mt-2 shadow pt-2"
                    >
                    <div className="ml-4 text-lg font-semibold mt-2">
                        Personalize Based on Bio
                        {(profile?.summary?.length < 20 || profile.summary === null) ?
                        null
                        :
                        <button 
                            className="float-right mr-3 mb-2 focus:outline-none"
                            onClick={() => regenInterests(
                                foundInts, 
                                setInterests, 
                                docId, 
                                fbProfile, 
                                setIntLoad,
                                auth,
                                docId,
                                profile
                            )}
                        >
                        <RefreshIcon className="border-2 border-blue-600 h-7 p-0.5 rounded-md bg-blue-600 text-white hover:bg-blue-500"/>
                        </button>
                        }
                    </div>
                    {intLoad ? 
                    <div className="justify-items-center text-center my-5">
                        <BounceLoader  css={override} color='#44A3CE'/>
                        <div>
                        <span className="animate-pulse text-center">
                        Hold on -- finding topics to write about.<br />This can take up to 30 seconds.
                        </span>
                        </div>
                    </div>
                    :
                    <ButtonsForInt 
                        interests={interests}
                        setIntVal={setIntVal}
                        onboarded={onboarded}
                        auth={auth}
                        intVal={intVal}
                        intLoad={intLoad}
                    />
                    }
                    <CustomTopic 
                    setIntVal={setIntVal}
                    onboarded={onboarded}
                    auth={auth}
                    intVal={intVal}
                    />
                    </div>
                    {/* Custom Topic Block*/}
                    {/* Linked Bio Info */}
                    <LinkedInHK 
                    url={url}
                    />
                    {/* Articles */}
                    {/* <div className="bg-white shadow sm:rounded-lg my-3 p-4 text-lg font-semibold">
                    Personalize Based on Article
                        {profile?.articles?.length > 0 ?
                        <div className="flex my-4">
                            {profile?.articles?.map((article, index) =>{
                                return(
                                    <div 
                                    key={index}
                                    className="text-base font-normal cursor-pointer mr-4 border-2 hover:shadow-lg border-gray-300 p-2 rounded-lg"
                                    >
                                    <div className="text-sm">
                                        {article.title}
                                    </div>
                                    <div className="mt-4 font-medium">
                                        {article.published_date.year}
                                    </div>
                                    </div>
                                )
                            })}
                        </div>
                        :
                        null
                        }
                    </div> */}
                    {/* Profile Activities */}
                    {/* {profile?.activities?.length > 0 ?
                    <div className="bg-white shadow sm:rounded-lg my-3 p-4 text-lg font-semibold">
                    Personalize Based on Recent Activity
                        <div>
                        <div className="flex my-4">
                            {profile?.activities?.map((activity, index) =>{
                                return(
                                    <div 
                                    key={index}
                                    className={classNames(
                                        intVal.title === activity.title ? "bg-blue-700 text-white border-2 border-blue-800" : "border-2 border-gray-400 text-gray-800", "text-base w-1/3 font-normal cursor-pointer mr-4 hover:shadow-lg p-2 rounded-lg"
                                    )}
                                    onClick={() =>setIntVal(activity)}
                                    >
                                    <div className="text-sm "
                                    style={{overflowWrap: 'anywhere'}}
                                    >
                                        {activity.title}
                                    </div>
                                    <div className="mt-4 font-medium">
                                        {activity.activity_status}
                                    </div>
                                    </div>
                                )
                            })}
                        </div>
                        </div>
                    </div>
                    :
                    null
                    } */}
                    {profile?.summary?.length > 10 ?
                    <div className="bg-white shadow sm:rounded-lg mt-3">
                        <div className='p-2 flex'>
                            <h2 className="text-lg font-semibold mt-2 ml-2">{profile.first_name}'s Bio</h2>
                            <div 
                                className="ml-auto p-2"
                            >
                                <a id="myLink" href={url} target="_blank" rel="noreferrer">
                                    <img src={LIlogo} alt="forBio" className="h-6" />
                                </a>
                            </div>
                        </div>
                        <div className='p-2 pl-4 pr-4 pt-1 pb-4'>
                            <p className="text-base">{profile?.summary}</p>
                        </div>
                    </div>
                    :
                    null
                    }
                </div>
                {/* Right Side Div */}
                <div className="bg-white shadow sm:rounded-lg w-1/2 ml-4 xs:mt-4 xs:ml-0 xs:w-full hover:shadow-lg">
                    {/* If content Gen is null then say generate, if it's not null then show message */}
                    <ContentGenerated 
                    profile={profile}
                    contentGen={contentGen}
                    generating={generating}
                    editing={editing}
                    setEditing={setEditing}
                    setContentGen={setContentGen} 
                    fbProfile={fbProfile} 
                    auth={auth}
                    docId={docId}
                    vProp={vProp}
                    intVal={intVal}
                    shownButton={shownButton}
                    firstCopy={firstCopy}
                    />
                    <div className="-mt-2 mb-5">
                    <CopyAndFireButtons 
                    contentGen={contentGen}
                    generating={generating}
                    fbProfile={fbProfile} 
                    docId={docId}
                    vProp={vProp}
                    intVal={intVal}
                    shownButton={shownButton}
                    firstCopy={firstCopy}
                    profile={profile}
                    setBtnClicked={setBtnClicked}
                    auth={auth}
                    fireClicked={fireClicked}
                    />
                    </div>
                    {/* {generating ? null :
                    <div className="float-right mr-4 mb-4">
                    <MsgAndInt 
                    shownButton={shownButton}
                    intVal={intVal}
                    />
                    </div>
                    } */}
                </div>
            </div>
            {/* Generate Button */}
            {/* <div className="bottom-0 my-0 fixed w-full flex flex-row-reverse bg-gray-900 h-14 left-0"> */}
                {/* <GenerateButton 
                shownButton={shownButton}
                profile={profile} 
                fbProfile={fbProfile} 
                vProp={vProp}
                intVal={intVal}
                auth={auth}
                setContentGen={setContentGen} 
                setGenerating={setGenerating}
                tokens={tokens}
                docId={docId}
                LIurl={url}
                interests={interests} 
                foundInts={foundInts}
                interestValues={interestValues}
                setBtnClicked={setBtnClicked}
                setShowTooltip={setShowTooltip}
                callToAction={callToAction}
                setEditing={setEditing}
                generating={generating}
                showBtn={showBtn}
                /> */}
                <div className="mr-6">
                    {/* <CopyAndFireButtons 
                    contentGen={contentGen}
                    generating={generating}
                    fbProfile={fbProfile} 
                    docId={docId}
                    vProp={vProp}
                    intVal={intVal}
                    shownButton={shownButton}
                    firstCopy={firstCopy}
                    profile={profile}
                    setBtnClicked={setBtnClicked}
                    auth={auth}
                    fireClicked={fireClicked}
                    /> */}
                </div>
                <div className="mr-auto ml-6 mt-1 w-240">
                    {/* Search */}
                    {/* <SearchProspect 
                    setShowSearching={setShowSearching}
                    setProfile={setProfile}
                    auth={auth}
                    fbProfile={fbProfile}
                    setFoundInts={setFoundInts}
                    setInterests={setInterests}
                    setDocId={setDocId}
                    setContentGen={setContentGen}
                    setError={setError}
                    url={url}
                    setURL={setURL}
                    setIntVal={setIntVal}
                    /> */}
                    {/* <button className="bg-gray border-2 border-gray-300">
                    Button
                    </button> */}
                {/* </div> */}
            </div>
        </div>
    )
}

export default Profile
